import { render, staticRenderFns } from "./yqJs.vue?vue&type=template&id=48b96a8d&scoped=true"
import script from "./yqJs.vue?vue&type=script&lang=js"
export * from "./yqJs.vue?vue&type=script&lang=js"
import style0 from "./yqJs.vue?vue&type=style&index=0&id=48b96a8d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b96a8d",
  null
  
)

export default component.exports